import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types/index';

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: User | null
  isAuthenticated: boolean
  isHydrated: boolean

  setAuth: (tokens: { access_token: string; refresh_token: string }, user: User) => void
  setTokens: (tokens: { access_token: string; refresh_token: string }) => void
  clear: () => void
  setHydrated: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,
      isHydrated: false,

      setAuth: (tokens, user) => {
        // Store both tokens for fallback - if HttpOnly cookie fails, we have refresh token
        set({
          accessToken: tokens.access_token,
          refreshToken: tokens.refresh_token,
          user,
          isAuthenticated: true,
          isHydrated: true,
        })
      },

      setTokens: (tokens) => {
        // Update both tokens on refresh
        set({
          accessToken: tokens.access_token,
          refreshToken: tokens.refresh_token,
        })
      },

      clear: () => {
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          isAuthenticated: false,
          // Keep isHydrated: true so routes can render
        })
      },

      setHydrated: () => set({ isHydrated: true }),
    }),
    {
      name: 'rto-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setHydrated()
        }
      },
    },
  ),
)
